const PlacesModes = {
	"geocode": "geocode"
}

const GeoCodeFilter = (list) => {
	if (list && list.results) {
		let out = list.results.map((item) => {
			return {
				value: item.formatted_address,
				link:  item.geometry.location.lat + ":" + item.geometry.location.lng
			};
		});
		return out;
	}
	return [];
};

class PlacesFilter {
	
	static getFilterFor (mode) {
		switch (mode) {
		case PlacesModes.geocode:
			return GeoCodeFilter;
		default:
			throw new Error(`${mode} filter not yet implemeneted`);
		}
	}
	
}

export { PlacesFilter, PlacesModes };